export default {
  login: {
    login: "登录",
    reset: "清空",
    userName: "用户名",
    password: "密码",
    enterUserName: "请输入用户名",
    enterPassword: "请输入密码",
  },
  route: {
    warehouseReceipt: "仓单出入库",
    warehouseReceiptInbound: "入库",
    warehouseReceiptOutbound: "出库",
    warehouseReceiptInboundImport: "仓单入库导入",
    warehouseReceiptOutboundImport: "仓单出库导入",
    warehouseReceiptAccountBookStock: "账册库存",
    warehouseReceiptOperation: "仓单业务任务",
    warehouseReceiptExpiryStock: "效期库存",
    home: "首页",
    download: "下载中心",
    changePassword: "修改密码",

    order: "订单管理",
    orderList: "订单列表",
    OpenPlatformOrderImport: "开放平台订单导入",

    declare: "订单管理",
    declareDetail: "申报详情",

    declareOrderList: "申报订单管理",
    declareOrderImport: "申报订单导入",
    customsDeclareDetail: "申报订单详情",

    goodsDeclareImport: "申报商品导入",

    warehouse: "仓库管理",
    "ex-warehouseList": "出库单管理",

    goods: "商品管理",
    goodsForRecordList: "商品备案",
    goodsList: "商品信息",

    taxesCommerce: "税金管理",
    taxesCommerceStatistics: "税金总览",
    taxCommerceAccountList: "税金帐户",
    taxesCommerceRechargeDetailList: "税金充值明细",
    taxesCommerceExpenseCalendarList: "税金消费记录",

    taxesClearanceCompany: "税金管理-清关公司",
    taxesClearanceCompanyStatistics: "税金统计",
    taxesClearanceCompanyRechargeDetailList: "税金充值明细-清关公司",
    taxesClearanceCompanyExpenseCalendarList: "税金消费明细-清关公司",

    taxesCommerceSupplier: "税金管理-电商企业管理货主版本",
    taxesCommerceSupplierStatistics: "税金统计",
    taxesCommerceSupplierRechargeDetailList: "货主税金充值明细",
    taxesCommerceSupplierExpenseCalendarList: "货主税金消费明细",

    stockControl: "库存管理",
    customerStockList: "库存查询",
    customerStockAccountList: "商家账册库存",
    customerDeclareOrderList: "商家订单查询",
    customerDeclareOrderDetail: "商家订单详情",

    carrierList: "快递管理",

    system: "系统管理",

    role: "角色管理",

    user: "用户列表",

    baseConfig: "基础配置信息",

    exceptionTask: "异常处理",

    channelView: "渠道管理",
    declareEnterpriseView: "申报企业管理",
    merchantView: "商户管理",
    shopAuthView: "店铺授权",
    channelEcommercePlatformView: "渠道电商平台",
    enterpriseAccountBookView: "企业账册管理",

    report: "报表管理",
    nuclearNoteView: "核注清单",

    goodsReturnManage: "退货单管理",
    returnQualityInspectionWorkbench: "退货质检工作台",
    returnQualityInspectionRecords: "退货质检记录",
    goodsReturnDetail: "退货订单详情",
    checkListManage: "核放单",
    checkListDetail: "核放单详情",
    booksManage: "账册库存",
    goodsRecordManage: "备案管理",
    customsInOutManage: "干线清关管理",
    recordManage: "账册库存",
    booksManageImport: "账册库存导入",
    nuclearNoteManage: "核注清单管理",
    cancelLationsManage: "撤单申报管理",
    orderActionRecord: "订单操作记录",
    importPreview: "导入预览",
    orderErrorList: "同步订单异常列表",

    purchaseManage: "采购管理",
    purchaseOrder: "入库管理",
    purchaseOrderDetail: "采购详情",
    purchaseOrderImport: "采购订单导入",

    heZhuOrder: "进口核注清单",
    heZhuOrderDetail: "核注清单详情",
    heZhuOrderImport: "核注清单导入",
    purchaseHeZhuOrder: "采购单核注清单列表",

    taxAccountList: "商家税金账户",
    b2bManage: "B端出库单管理",
    b2b: "出库管理",
    b2bCreate: "创建ToB出库单",
    b2bHeZhuOrder: "出口核注清单",
    b2bHeZhuOrderDetail: "出口核注清单详情",

    douYinTraceLog: "抖音轨迹日志",
    customer: "货主管理",
    returnDeclareOrderManage: "退货申报单管理",
    returnDeclareOrderHeZhuOrder: "退货申报核注单",
    returnDeclareOrderHeZhuOrderDetail: "退货申报核注单详情",
    returnManage: "退货管理",
    douYinWarehouseFeeOrder: "抖音仓租单",
    ecommerceHeZhu: "电商核注单",
    eCommerceHeZhuDetail: "电商核注单详情",

    orderNotifyConfig: "抖音异常通知配置",
    stockAdjustRecord: "库存调整记录",
    customerPurchaseList: "商家入库单",
    customerToBOrderList: "商家出库单",
    itemNoMapping: "商品编码映射",
    dataExport: "数据导出",
  },
};
